import {hideCartTesInStock, showDropShipInStock} from '../productShippingInfo';
import $ from 'jquery';
import {tooltipProxy as tooltip} from '../../../smartpak/tooltipproxy';
import slideInPanel from './slideinpanel';
import applepayhelper from './../../applepay/applepayhelper';
import initApplePay, { redirectURL } from './../../applepay/applepay';
import page from '../../../smartpak/page';

let $miniCart, panel;
const totals = {label: 'Checkout with Apple Pay', amount: '0.00', type: 'pending'};

const miniCart = {
    _displayApplePay: function () {
        if (applepayhelper.displayApplePay) {
            $miniCart.find('.apple-pay-button-container')?.removeClass('jsHide');
        }
    },
    _loadResults: function (html) {
        $miniCart.html(html);
    },
    _closeMiniCart: function () {
        if (panel) {
            panel.close();
        }
    },
    _addCloseClick: function () {
        $miniCart.one('click', '#continueShopping', function (e) {
            e.preventDefault();
            miniCart._closeMiniCart();
        });
    },

    _addArrivalDateToolTip: function () {
        $miniCart.find('a.itemArrivalDate').each(function () {
            // eslint-disable-next-line no-invalid-this
            var $link = $(this),
                contentDiv = $('#' + $link.data('contentid')).html();

            tooltip($link, {
                content: contentDiv,
                width: 150
            });
        });
    },

    _hideFlyStopperSpecificContent: function () {
        var productName = $miniCart.find('#meta h3').html(),
            isFlyStopper = /fly stopper/gi.test(productName);

        if (isFlyStopper) {
            $miniCart.find('.onBackOrder').hide();
            $miniCart.find('.cartPromoArea').hide();
        }
    },

    _handleUpSell() {
        if (document.getElementById('show-up-sell')) {
            if (hideCartTesInStock()) {
                [].slice.call(document.querySelectorAll('.availabilityStatus')).forEach(function ($element) {
                    $element.classList.add('hideShipInfo');
                });
            }

            showDropShipInStock();
        }
    },

    _hideETA: function ($miniCart) {
        $miniCart.find('#item-added .etaArrival').remove();
    },

    _setupApplePay: function (totals, { onWalletItemSaved, onSuccess }) {
        initApplePay(totals, { onWalletItemSaved, onSuccess });
    },

    show: function (html, shouldHideETA) {
        $miniCart = $('<div></div>');
        miniCart._loadResults(html);
        miniCart._addCloseClick();
        miniCart._addArrivalDateToolTip();
        miniCart._hideFlyStopperSpecificContent();
        miniCart._displayApplePay();

        if (shouldHideETA) {
            miniCart._hideETA($miniCart);
        }

        panel = slideInPanel({
            title: 'Added to Cart!',
            $content: $miniCart.get(0)
        });

        panel.open();

        miniCart._handleUpSell();
        tooltip($('#perksWhy'), {placement: 'left', width: 300});

        miniCart._setupApplePay(totals, {
            onWalletItemSaved: miniCart._closeMiniCart,
            onSuccess: () => page.redirectToUrl(redirectURL)
        });
    }
};

export default miniCart;
